export function ensureSafeLinkHref(value: string): string | null {
  const raw = value.trim()
  if (!raw) return null

  if (raw.startsWith("mailto:") || raw.startsWith("tel:")) {
    return raw
  }

  if (raw.startsWith("http://") || raw.startsWith("https://")) {
    return raw
  }

  if (raw.startsWith("//")) {
    return `https:${raw}`
  }

  if (raw.startsWith("/")) {
    return raw
  }

  return `https://${raw}`
}
